import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
import {QualificationInfo}from 'src/api/systemManage/qualification/';
interface QualificationInterface extends QualificationInfo {
    qualificationId?: string;
    companyId?: string;
}

export default class ModulesState extends ModulesStateBasic {
    public qualificationList: Array<QualificationInterface> = [];
    public qualificationInfo: QualificationInterface = {};
    public uploadTokenData: any = {};
    public watchVisible: boolean = false;
    public deleteVisible: boolean = false;
    public industryList: Array<any> = [];
    public snapImg: string = '';
    public willDeleteQualification: QualificationInterface = {};
    public modalImgIs: number = 0; // 0 -> demo图片，1->上传成功的图片
    public editStartValue: Date;
    public editEndValue: Date;
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Qualification/Modules.State.ts